import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import './index.css'
import App from './App.jsx'
import { initSentry } from './analytics/sentry'

// Initialize Sentry before React renders
// Get DSN from environment variable
const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
const shouldEnableSentry = 
  sentryDsn && 
  (import.meta.env.MODE === 'production' || import.meta.env.VITE_SENTRY_ENABLED === 'true');

if (shouldEnableSentry) {
  initSentry({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
  });
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>
)
